import { Role } from 'auth';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import IssuedCapitalChart from '@/modules/issuer-dashboard/components/IssuedCapitalChart.tsx';
import TopHoldersChart from '@/modules/issuer-dashboard/components/TopHoldersChart.tsx';
import CapitalSummary from '@/modules/issuer-dashboard/components/dashboard/CapitalSummary.tsx';
import Nav from '@/modules/issuer-dashboard/components/dashboard/Nav.tsx';
import Notifications from '@/modules/issuer-dashboard/components/dashboard/Notifications.tsx';
import PendingApplicationSummary from '@/modules/issuer-dashboard/components/dashboard/PendingApplicationSummary.tsx';
import { SecurityClasses } from '@/modules/issuer-dashboard/components/securities-dashboard/SecurityClasses.tsx';
import { PageLayout } from 'ui';

const IssuerDashboard = () => {
  return (
    <PageLayout title="Dashboard">
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <TopHoldersChart holderSearch subtitle />
          <Notifications />
        </div>

        <PendingApplicationSummary />
        <CapitalSummary />
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <IssuedCapitalChart />
          <Nav />
        </div>

        <SecurityClasses />
      </div>
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerDashboard, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
